<template>
  <div>
    <validation-observer v-slot="{ invalid }" ref="observer">
      <b-form @submit.prevent="saveCar" class="tt-mt">
        <div class="row">
          <b-form-group id="input-group-2" class="col-md-12">
            <validation-provider
              :rules="'required|is_not:' + (editableCar ? '' : savedCars)"
              v-slot="{ errors }"
            >
              <b-form-input
                id="input-2"
                required
                placeholder="Car make"
                v-model="car.make"
                aria-required="true"
              ></b-form-input>
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </b-form-group>
          <b-form-group id="input-group-3" class="col-md-12">
            <validation-provider :rules="'required'" v-slot="{ errors }">
              <b-form-input
                id="input-2"
                required
                placeholder="Car model"
                v-model="car.model"
                aria-required="true"
              ></b-form-input>
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </b-form-group>
          <b-form-group id="input-group-4" class="col-md-12">
            <validation-provider :rules="'required'" v-slot="{ errors }">
              <b-form-input
                id="input-2"
                required
                placeholder="Car registration number"
                v-model="car.registration_number"
                aria-required="true"
              ></b-form-input>
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </b-form-group>
          <b-form-group id="input-group-5" class="col-md-12">
            <validation-provider :rules="'required'" v-slot="{ errors }">
              <datetime
                type="date"
                v-model="car.purchase_date"
                placeholder="Car purchase date"
                :input-class="{ 'form-control': true, 'is-invalid': errors[0] }"
              >
              </datetime>

              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </b-form-group>
          <b-form-group id="input-group-9" class="col-md-12">
            <validation-provider :rules="'required'" v-slot="{ errors }">
              <b-form-input
                id="input-2"
                required
                placeholder="Car cost"
                v-model="car.cost_price"
                aria-required="true"
              ></b-form-input>
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </b-form-group>

          <b-form-group class="col-md-12 text-left">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-radio
                name="is_purchase"
                v-model="car.is_purchase"
                :value="true"
                class="pr-3"
                inline
                >Purchased Car</b-form-radio
              >
              <b-form-radio
                name="is_purchase"
                v-model="car.is_purchase"
                :value="false"
                class="pr-3"
                inline
                >Leased Car</b-form-radio
              >
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="col-md-12 text-left">
            <button
              type="submit"
              class="align-content-start btn text-white pr-5 pl-5 btn-primary tt-border-radius w-100"
              :disabled="invalid"
            >
              Save Car
            </button>
          </b-form-group>
        </div>
      </b-form>
    </validation-observer>
    <div class="mt-3">
      <hr />
      <car @editableCar="setEditableCar"></car>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { DateTime as TimeFormatter } from "luxon";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { is_not } from "vee-validate/dist/rules";
import Car from "@/views/Car";
import "vue-datetime/dist/vue-datetime.css";
import { Datetime } from "vue-datetime";
import sha1 from "js-sha1";

extend("is_not", {
  ...is_not,
  validate(value, args) {
    return !args.other.includes(value);
  },
  message: "This name is already in use. please enter another name"
});
export default {
  name: "NewCar",
  components: {
    ValidationProvider,
    ValidationObserver,
    Car,
    Datetime
  },
  props: {
    editableCar: {
      // type: Object,
      required: false
    }
  },
  data() {
    return {
      car: {
        _id: new Date().toISOString(),
        type: "vehicle",
        is_synced: false,
        is_default_car: false,
        is_deleted: false,
        make: "",
        model: "",
        hash: "",
        name: "Car 1",
        registration_number: "",
        cost_price: "",
        is_purchase: "",
        purchase_date: new Date().toISOString(),
        time: TimeFormatter.fromISO(new Date().toISOString()).toFormat(
          "y-MM-dd"
        ),
        saved_at: new Date().toISOString()
      }
    };
  },
  created() {
    this.$store.dispatch("auth/checkAuthAction");
    this.car.hash = sha1(new Date().toISOString() + Math.random());
  },
  methods: {
    saveCar: function() {
      this.$root.$emit("newRecordSaved");
      TimeFormatter.fromISO(this.car.purchase_date).toFormat("y-MM-dd");
      this.$store.dispatch("saveRecords", this.car);
      this.$store.dispatch("car/getAllCarsAction");
      this.$root.$emit("newRecordSaved");
      this.$refs.observer.reset();
    },
    resetForm: function() {
      this.car._id = new Date().toISOString();
      this.car.name = "";
      this.car.is_synced = false;
      this.car.make = "";
      this.car.model = "";
      this.car.registration_number = "";
      this.car.cost_price = "";
      this.car.hash = sha1(new Date().toISOString() + Math.random());
      this.car.time = TimeFormatter.fromISO(new Date().toISOString()).toFormat(
        "y-MM-dd H:mm:s"
      );
    },
    setEditableCar: function(car) {
      this.car = car;
      this.car.is_synced = false;
    }
  },
  computed: {
    ...mapGetters({
      perfectSave: "getIsSucces",
      failedSave: "getIsError"
    }),
    ...mapState({
      vehicles: state => state.car.allCars
    }),
    savedCars: function() {
      var savedCarsArr = [];
      try {
        this.vehicles.map(car => {
          savedCarsArr.push(car.name);
        });
      } catch (e) {
        console.log(e);
      }
      return savedCarsArr;
    }
  },
  watch: {
    editableCar: function(value) {
      if (Object.keys(this.editableCar).length > 0) {
        this.car = value;
      }
    }
  }
};
</script>

<style scoped></style>
